
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["expensive","createFilterTree","_fetchFilters","createFilterTreeFromConfigurations","createConfigurationArray"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "5fd56f7b8c4ad7acd799.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			